import { render } from "./SectionBackground.vue?vue&type=template&id=13178fe8"
import script from "./SectionBackground.vue?vue&type=script&lang=js"
export * from "./SectionBackground.vue?vue&type=script&lang=js"

import "./SectionBackground.vue?vue&type=style&index=0&id=13178fe8&lang=css"
script.render = render

export default script